import React, { useEffect, useState, memo } from "react";
//import { pretendModelData } from "../pretendModelData";
import ModelArchiveThumbs from "./ModelArchiveThumbs";
import PopUp from "../components/PopUp";
import Constants from "../constants/Constants";
import Loader from "./Loader";
import { Link, useLocation } from "@reach/router";
import "../css/tagged.css";
const Tagged = (props) => {
  const { state } = useLocation();
  let topStop = "0";
  if (state && "fromFriend" in state) {
    topStop = state.fromFriend;
  }
  const [updates, setUpdates] = useState([]);
  const [sortedKeys, setSortedKeys] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [model, setModel] = useState({});
  const [structured, setStructured] = useState({});
  const [currentHash, setCurrentHash] = useState("");
  const [search, setSearch] = useState("");
  const join = (modelVar) => {
    setModel(modelVar);
  };
  const {
    dispatch,
    pos,
    scrollSite,
    tagName,
    actives,
    allSites,
    biller,
  } = props;

  useEffect(() => {
    if (pos > 0 && scrollSite === tagName) {
      setTimeout(() => window.scrollTo({ top: pos, left: 0 }), 900);
    }
  }, [pos, tagName, scrollSite]);
  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${Constants.API}tagged-videos.php?tag=${props.tagName}`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if ("error" in res) {
          console.log("need to handle this error", res);
        } else {
          let sortingKeys = [];
          const structuredVideos = {};
          res.videos.forEach((v) => {
            if (v.site_id in structuredVideos) {
              structuredVideos[v.site_id] = [...structuredVideos[v.site_id], v];
            } else {
              sortingKeys.push(v.site_id);
              structuredVideos[v.site_id] = [v];
            }
          });
          sortingKeys = sortingKeys.filter((s) => s !== topStop);
          if (topStop !== "0") {
            sortingKeys = [topStop, ...sortingKeys];
          }
          setSortedKeys(sortingKeys);
          setStructured(structuredVideos);
          setUpdates(res.videos);
          setCurrentHash(res.hash);
          setIsLoading(false);
        }
      });
    // setUpdates(pretendModelData);
    // setIsLoading(false);
    // setTimeout(() => {
    //   setUpdates(pretendModelData);
    //   setIsLoading(false);
    // }, 4000);
  }, [props.tagName, actives, topStop]);
  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="general_page">
      <div className="user_panel">
        <div className="flex">
          {search === "" ? (
            <div className="information">
              <div className="name">
                #<strong>{currentHash.hash_tag}</strong>
              </div>
            </div>
          ) : (
            <div className="information">
              <div className="name">
                Searching for: <strong>{search}</strong>
              </div>
            </div>
          )}
          <div
            className={
              search === "" ? "titleSearchContain" : "titleSearchContain full"
            }
          >
            <input
              type="text"
              placeholder={`search page`}
              value={search}
              className="titleSearch"
              onChange={(e) => {
                setSearch(e.target.value);
                window.scrollTo(window.scrollX, window.scrollY - 1);
                window.scrollTo(window.scrollX, window.scrollY + 1);
              }}
            />
          </div>
        </div>
      </div>
      <div className="tab_content">
        <div id="tab1" className="tab_box active">
          {search !== "" ? (
            <div className="thumbs tagged">
              {updates
                .filter((v) =>
                  v.title.toLowerCase().includes(search.toLowerCase())
                )
                .map((video) => (
                  <ModelArchiveThumbs
                    video={video}
                    key={`va${video.id}`}
                    tags={""}
                    file={{
                      file_name: video.file_name,
                      trailer: video.trailer,
                    }}
                    site={allSites[video.site_id]}
                    modelName={tagName}
                    actives={actives}
                    dispatch={dispatch}
                    isActive={actives.includes(video.site_id) ? true : false}
                    join={join}
                  />
                ))}
            </div>
          ) : (
            sortedKeys.map((s) => {
              if (!(s in allSites)) {
                console.log("its here!!!!");
                console.log("s", s);
                console.log("sortedKeys", sortedKeys);
                console.log("allSites", allSites);
              }
              return (
                <div key={`breaks-${s}`}>
                  <div className="friendInfo">
                    <div className="friendImg">
                      <Link to={`${Constants.MA}${allSites[s].site_url}`}>
                        <img
                          src={`https://static.addfriends.com/images/${allSites[s].site_url}.jpg`}
                          alt={`${allSites[s].site_name}'s #${currentHash.hash_tag} Videos`}
                        />
                      </Link>
                    </div>
                    <div>
                      <div className="friendName">{allSites[s].site_name}</div>
                      <div className="friendVideoInfo">
                        has {structured[s].length}{" "}
                        <strong>#{currentHash.hash_tag}</strong> videos
                      </div>
                    </div>
                  </div>
                  <div className="thumbs tagged">
                    {structured[s].map((video) => (
                      <ModelArchiveThumbs
                        video={video}
                        key={`va${video.id}`}
                        tags={""}
                        file={{
                          file_name: video.file_name,
                          trailer: video.trailer,
                        }}
                        site={allSites[video.site_id]}
                        modelName={tagName}
                        actives={actives}
                        dispatch={dispatch}
                        isActive={
                          actives.includes(video.site_id) ? true : false
                        }
                        join={join}
                      />
                    ))}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {Object.keys(model).length > 0 ? (
        <PopUp join={join} model={model} dispatch={dispatch} biller={biller} />
      ) : null}
    </div>
  );
};

export default memo(Tagged);
